import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AOS from "aos";
import { Toaster } from "sonner";

import SmoothScrollProvider from "@/components/SmoothScrollProvider";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import SchoolCourses from "@/pages/SchoolCourses";
import CompetitiveExams from "@/pages/CompetitiveExams";
import GovernmentCourses from "@/pages/GovernmentCourses";
import Languages from "@/pages/Languages";
import ITCourses from "@/pages/ITCourses";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-out-cubic", once: true, offset: 60 });
  }, []);

  return (
    <div className="App font-poppins">
      <Toaster richColors position="top-right" />
      <HelmetProvider>
      <SmoothScrollProvider>
        <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/school-courses" element={<SchoolCourses />} />
            <Route path="/competitive-exams" element={<CompetitiveExams />} />
            <Route path="/government-courses" element={<GovernmentCourses />} />
            <Route path="/courses" element={<Navigate to="/school-courses" replace />} />
            <Route path="/languages" element={<Languages />} />
            <Route path="/it-courses" element={<ITCourses />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </SmoothScrollProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
